module.exports = __webpack_public_path__ + "41df658946e70f81088aa23ad9914b6b.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-28.svg
// module id = 570
// module chunks = 0